import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import convertToNestedArray from "@sourceflow-uk/functions/convertToNestedArray";
import data from "@sourceflow/main_menu.json";

export const useMainMenu = () => convertToNestedArray(useSourceFlowCollection(data));

export default useMainMenu;
